import { iconMap } from './icons';

interface IconProps {
  icon: string;
  className?: string;
}

const Icon = ({ icon, className = "" }: IconProps) => {
  const IconComponent = iconMap[icon];
  
  if (!IconComponent) {
    console.warn(`Icon "${icon}" not found in iconMap`);
    return null;
  }

  return (
    <div className={`icon-wrapper inline-block ${className}`} data-icon={icon}>
      <IconComponent />
    </div>
  );
};

export default Icon;
